import {
    Branch, StockTransfer, Currency
} from 'ep-bt-field-agent-proxy';

import { EpbtFaQuickTransferLineModel } from './epbt-fa-quick-transfer-line-model';


export class EpbtFaQuickTransferModel {

    constructor() { }

    public stockTransfer: StockTransfer;
    public sourceBranch: Branch;
    public destBranch: Branch;
    public departmentIndex: number;
    public departmentToIndex: number;
    public quickTransferLines: EpbtFaQuickTransferLineModel[] = [];
    public currency: Currency;
    public selectedLineIndex: number;

    public lineAdd(line: EpbtFaQuickTransferLineModel, adding: boolean = true) {
        line.lineNumber = this.quickTransferLines.length + 1;
        line.adding = adding;
        this.quickTransferLines.push(line);
        // set last added line as selected
        this.selectedLineIndex = this.quickTransferLines.length;
    }
}
